export function initStonly(): void {
	window.STONLY_WID = '54bfc6cc-ecc1-11ec-9fb8-0ae9fa2a18a2';

	(function (
		s: Window,
		t: Document,
		o: 'script',
		n: string,
		l: HTMLScriptElement | null,
		y: HTMLScriptElement,
		w: StonlyWidget,
		g: XMLHttpRequest
	) {
		s.StonlyWidget ||
			(((w = s.StonlyWidget =
				function (this: StonlyWidget, ...args: any[]) {
					w._api ? w._api.apply(w, arguments) : w.queue.push(arguments);
				} as StonlyWidget).scriptPath = n),
			(w.queue = []),
			((y = t.createElement(o)).async = true),
			(g = new XMLHttpRequest()).open('GET', n + 'version?v=' + Date.now(), true),
			(g.onreadystatechange = function () {
				4 === g.readyState &&
					((y.src = n + 'stonly-widget.js?v=' + (200 === g.status ? g.responseText : Date.now())),
					(l = t.getElementsByTagName(o)[0]).parentNode!.insertBefore(y, l));
			}),
			g.send());
	})(window, document, 'script', 'https://stonly.com/js/widget/v2/', null!, undefined!, undefined!, undefined!);
}
